import React from 'react';
import { AdminLayout } from '../../components/layout/AdminLayout';
import { useTenant } from '../../lib/tenant-context';
import { useLoyaltyDashboard, useLoyaltyToggle } from '../../lib/loyalty-hooks';
import { Card } from '../../components/ui/Card';
import { Users, Star, Gift, Trophy, Power, Loader2 } from 'lucide-react';
import { formatCurrency } from '../../lib/utils';
export function LoyaltyDashboardPage() {
  const {
    restaurant,
    role,
    signOut
  } = useTenant();
  const {
    customers,
    loading
  } = useLoyaltyDashboard(restaurant.restaurant_id);
  const {
    isActive,
    loading: toggleLoading,
    saving,
    toggle
  } = useLoyaltyToggle(restaurant.restaurant_id);
  const totalCustomers = customers.length;
  const totalPoints = customers.reduce((sum, c) => sum + (c.current_points || 0), 0);
  const totalRewardsAvailable = customers.reduce((sum, c) => sum + (c.available_rewards_count || 0), 0);
  const totalRewardsRedeemed = customers.reduce((sum, c) => sum + (c.redeemed_rewards_count || 0), 0);
  return <AdminLayout restaurant={restaurant} role={role} onSignOut={signOut} data-id="element-5033" data-mp="17ahquv65n2vb">
      <div className="p-6 max-w-7xl mx-auto space-y-6" data-id="element-5034" data-mp="139xp1eamzb2u">
        <div data-id="element-5035" data-mp="1gzrgm4dj09g9">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-5036" data-mp="1h0kml34nuuxc">
            Programa de Lealtad
          </h1>
          <p className="text-gray-500" data-id="element-5037" data-mp="1c92m0g6juwcw">
            Gestiona tus clientes frecuentes y beneficios
          </p>
        </div>

        {/* Activation toggle */}
        <Card className={`p-6 border-2 transition-colors ${isActive ? 'border-emerald-200 bg-emerald-50/40' : 'border-gray-200 bg-gray-50'}`} data-id="element-5038" data-mp="1r01r3h86f2rq">
          <div className="flex items-center justify-between gap-6 flex-wrap" data-id="element-5039" data-mp="1zydi3kcyg2kp">
            <div className="flex items-center gap-4" data-id="element-5040" data-mp="1v0vhch93ctns">
              <div className={`w-12 h-12 rounded-xl flex items-center justify-center shrink-0 ${isActive ? 'bg-emerald-100' : 'bg-gray-200'}`} data-id="element-5041" data-mp="1uxzgol5uzqvn">
                <Power className={`w-6 h-6 ${isActive ? 'text-emerald-600' : 'text-gray-500'}`} data-id="element-5042" data-mp="nm2sb1ouhyo" />
              </div>
              <div data-id="element-5043" data-mp="25mlusrjznq5o">
                <div className="flex items-center gap-2" data-id="element-5044" data-mp="25o6s2oxotn78">
                  <h2 className="font-bold text-gray-900" data-id="element-5045" data-mp="2am8b59v45mip">
                    Sistema de Lealtad
                  </h2>
                  <span className={`text-xs font-bold px-2 py-0.5 rounded-full ${isActive ? 'bg-emerald-100 text-emerald-700' : 'bg-gray-200 text-gray-600'}`} data-id="element-5046" data-mp="2eo26d2mjhybh">
                    {toggleLoading ? '...' : isActive ? 'ACTIVO' : 'INACTIVO'}
                  </span>
                </div>
                <p className="text-sm text-gray-500 mt-0.5" data-id="element-5047" data-mp="2te108t72anl5">
                  {isActive ? 'Cada pedido pagado con teléfono acumula puntos para el cliente.' : 'Los pedidos no acumulan puntos. Activa el programa para empezar a premiar a tus clientes.'}
                </p>
              </div>
            </div>

            <button onClick={() => toggle(!isActive)} disabled={saving || toggleLoading} className={`relative inline-flex items-center h-9 px-1 rounded-full transition-colors w-20 shrink-0 disabled:opacity-60 ${isActive ? 'bg-emerald-500' : 'bg-gray-300'}`} aria-label={isActive ? 'Desactivar lealtad' : 'Activar lealtad'} data-id="element-5048" data-mp="vp49mgwvayl3">
              <span className={`inline-flex items-center justify-center w-7 h-7 rounded-full bg-white shadow transform transition-transform ${isActive ? 'translate-x-11' : 'translate-x-0'}`} data-id="element-5049" data-mp="1eflygaekxa16">
                {saving && <Loader2 className="w-3.5 h-3.5 animate-spin text-gray-500" data-id="element-5050" data-mp="15m0i4mmrnkpn" />}
              </span>
            </button>
          </div>
        </Card>

        {/* KPIs */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-5051" data-mp="1y4ny5nmwo9jv">
          <Card className="p-6" data-id="element-5052" data-mp="1tcco3rygb7dl">
            <div className="flex items-center gap-4" data-id="element-5053" data-mp="1tbbdfolckmwe">
              <div className="w-12 h-12 bg-blue-50 rounded-xl flex items-center justify-center shrink-0" data-id="element-5054" data-mp="1cxn45y535zif">
                <Users className="w-6 h-6 text-blue-600" data-id="element-5055" data-mp="1hwzp2dcecwid" />
              </div>
              <div data-id="element-5056" data-mp="13wown5vfv9v3">
                <p className="text-sm text-gray-500 font-medium" data-id="element-5057" data-mp="13x8buetpfk5f">
                  Clientes Leales
                </p>
                <p className="text-2xl font-bold text-gray-900" data-id="element-5058" data-mp="18wtg94rn8kpj">
                  {totalCustomers}
                </p>
              </div>
            </div>
          </Card>
          <Card className="p-6" data-id="element-5059" data-mp="20nhcc2egmzwc">
            <div className="flex items-center gap-4" data-id="element-5060" data-mp="20lo6gpbo8jpe">
              <div className="w-12 h-12 bg-yellow-50 rounded-xl flex items-center justify-center shrink-0" data-id="element-5061" data-mp="1mvt101c1cfgf">
                <Star className="w-6 h-6 text-yellow-600" data-id="element-5062" data-mp="1ru4auc2bypyn" />
              </div>
              <div data-id="element-5063" data-mp="2fk8e2iblwnp4">
                <p className="text-sm text-gray-500 font-medium" data-id="element-5064" data-mp="2fjou6w2ebp8g">
                  Puntos Emitidos
                </p>
                <p className="text-2xl font-bold text-gray-900" data-id="element-5065" data-mp="2kc05sw6i0zgu">
                  {totalPoints}
                </p>
              </div>
            </div>
          </Card>
          <Card className="p-6" data-id="element-5066" data-mp="2pof01d0x7dhy">
            <div className="flex items-center gap-4" data-id="element-5067" data-mp="2pndq5bvn4x1t">
              <div className="w-12 h-12 bg-green-50 rounded-xl flex items-center justify-center shrink-0" data-id="element-5068" data-mp="33fk3yrbbmry3">
                <Gift className="w-6 h-6 text-green-600" data-id="element-5069" data-mp="2ygqsf4flhb0k" />
              </div>
              <div data-id="element-5070" data-mp="2yitghix6su2n">
                <p className="text-sm text-gray-500 font-medium" data-id="element-5071" data-mp="2aqmloo740v5c">
                  Beneficios Disponibles
                </p>
                <p className="text-2xl font-bold text-gray-900" data-id="element-5072" data-mp="26qchnh2voet4">
                  {totalRewardsAvailable}
                </p>
              </div>
            </div>
          </Card>
          <Card className="p-6" data-id="element-5073" data-mp="2fpg1in9vcy8o">
            <div className="flex items-center gap-4" data-id="element-5074" data-mp="2fp7lwnmd3ets">
              <div className="w-12 h-12 bg-purple-50 rounded-xl flex items-center justify-center shrink-0" data-id="element-5075" data-mp="3w3z8ul0qntvp">
                <Trophy className="w-6 h-6 text-purple-600" data-id="element-5076" data-mp="3r5nz0aag1jdh" />
              </div>
              <div data-id="element-5077" data-mp="30g7mm1b68cx">
                <p className="text-sm text-gray-500 font-medium" data-id="element-5078" data-mp="30zi5hompugx">
                  Beneficios Redimidos
                </p>
                <p className="text-2xl font-bold text-gray-900" data-id="element-5079" data-mp="70qbnt5jiop5">
                  {totalRewardsRedeemed}
                </p>
              </div>
            </div>
          </Card>
        </div>

        {/* Customer Table */}
        <Card className="overflow-hidden" data-id="element-5080" data-mp="gzftxn1cmb5x">
          <div className="p-6 border-b border-gray-200" data-id="element-5081" data-mp="3fid0rsu1ougu">
            <h2 className="font-bold text-gray-900" data-id="element-5082" data-mp="3ffry51lxaai1">Directorio de Clientes</h2>
          </div>
          <div className="overflow-x-auto" data-id="element-5083" data-mp="3kh7lx1fhiv44">
            <table className="w-full text-left text-sm" data-id="element-5084" data-mp="3pfir2yuu4hg0">
              <thead className="bg-gray-50 text-gray-500" data-id="element-5085" data-mp="3pdxxbbgch2j7">
                <tr data-id="element-5086" data-mp="3u7sp7263sntd">
                  <th className="px-6 py-4 font-medium" data-id="element-5087" data-mp="3u8bw7nu7trsm">Cliente</th>
                  <th className="px-6 py-4 font-medium" data-id="element-5088" data-mp="2ws533q946w81">Teléfono</th>
                  <th className="px-6 py-4 font-medium text-right" data-id="element-5089" data-mp="31qgcy0zet6q9">Visitas</th>
                  <th className="px-6 py-4 font-medium text-right" data-id="element-5090" data-mp="31odcso4jlx7t">
                    Total Gastado
                  </th>
                  <th className="px-6 py-4 font-medium text-right" data-id="element-5091" data-mp="2p83y4m70gzsp">
                    Ticket Promedio
                  </th>
                  <th className="px-6 py-4 font-medium text-right" data-id="element-5092" data-mp="2k7pztvv7p47v">Puntos</th>
                  <th className="px-6 py-4 font-medium" data-id="element-5093" data-mp="2f9wroxacm04y">Nivel</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200" data-id="element-5094" data-mp="2b8l40xb1boze">
                {loading ? <tr data-id="element-5095" data-mp="26hmgbcnpvom4">
                    <td colSpan={7} className="px-6 py-8 text-center text-gray-500" data-id="element-5096" data-mp="26gbevjhqusy6">
                      Cargando clientes...
                    </td>
                  </tr> : customers.length === 0 ? <tr data-id="element-5097" data-mp="1rkbxtjcnpigw">
                    <td colSpan={7} className="px-6 py-8 text-center text-gray-500" data-id="element-5098" data-mp="1riska0idxlit">
                      No hay clientes registrados aún.
                    </td>
                  </tr> : customers.map(customer => <tr key={customer.customer_id} className="hover:bg-gray-50" data-id="element-5099" data-mp="3gc6v78oatxnr">
                      <td className="px-6 py-4 font-medium text-gray-900" data-id="element-5100" data-mp="31gh4ix864wcp">
                        {customer.name || 'Sin nombre'}
                      </td>
                      <td className="px-6 py-4 text-gray-500" data-id="element-5101" data-mp="2so5evdkvpcxs">
                        {customer.phone}
                      </td>
                      <td className="px-6 py-4 text-right text-gray-900" data-id="element-5102" data-mp="2xg703p00ydzy">
                        {customer.total_orders}
                      </td>
                      <td className="px-6 py-4 text-right text-gray-900" data-id="element-5103" data-mp="2nplv9jtrcd8l">
                        {formatCurrency(customer.total_spent, restaurant.currency_symbol)}
                      </td>
                      <td className="px-6 py-4 text-right text-gray-500" data-id="element-5104" data-mp="2dqmx4v6mbzzu">
                        {formatCurrency(customer.total_spent / Math.max(1, customer.total_orders), restaurant.currency_symbol)}
                      </td>
                      <td className="px-6 py-4 text-right font-bold text-brand-charcoal" data-id="element-5105" data-mp="1z4z6cr5wtx80">
                        {customer.current_points}
                      </td>
                      <td className="px-6 py-4" data-id="element-5106" data-mp="2dzvobw3ityya">
                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-5107" data-mp="293oqkqla3trf">
                          {customer.current_level || 'Inicial'}
                        </span>
                      </td>
                    </tr>)}
              </tbody>
            </table>
          </div>
        </Card>
      </div>
    </AdminLayout>;
}